/* Take the quiz (2026-10-09). Three steps: welcome, one goal, signup. Posts the same payload shape as
   assets/email-popup.js: {
  if(window.__bwQuizInitialized)return;
  window.__bwQuizInitialized=true; email, wellness_goal, source, phone, sms_consent }. A goal is a browsing intention.
   Surfaces a failed capture instead of faking success (founder decision 2026-09-11 for the popup). */
(function () {
  'use strict';
  var instances = new Map();
  function initialize(root) {
  if (instances.has(root)) return;
  var lifecycle = new AbortController();
  var listen = function(node,event,handler){if(node)node.addEventListener(event,handler,{signal:lifecycle.signal});};
  var generation=0, pending=false, requestController=null;
  function invalidate(){generation++;pending=false;if(requestController)requestController.abort();if(submitBtn){submitBtn.disabled=false;submitBtn.removeAttribute('aria-busy');}}
  instances.set(root,function(){invalidate();lifecycle.abort();});

  var ENDPOINT = root.getAttribute('data-endpoint') || '';
  var SOURCE = root.getAttribute('data-source') || 'optibio-quiz-page';
  var steps = [].slice.call(root.querySelectorAll('[data-bw-step]'));
  var label = root.querySelector('[data-bw-quiz-label]');
  var count = root.querySelector('[data-bw-quiz-count]');
  var line = root.querySelector('[data-bw-quiz-line]');
  var goals = [].slice.call(root.querySelectorAll('[data-bw-goal]'));
  var goalError = root.querySelector('[data-bw-goal-error]');
  var heading = root.querySelector('[data-bw-quiz-heading]');
  var copy = root.querySelector('[data-bw-quiz-copy]');
  var related = root.querySelector('[data-bw-quiz-related]');
  var form = root.querySelector('[data-bw-quiz-form]');
  var formError = root.querySelector('[data-bw-form-error]');
  var submitBtn = root.querySelector('[data-bw-quiz-submit]');
  var doneCopy = root.querySelector('[data-bw-quiz-done-copy]');
  var restart = root.querySelector('[data-bw-quiz-restart]');
  var goalErrorCopy = (root.closest('.bw-quiz') && root.closest('.bw-quiz').getAttribute('data-goal-error')) || 'Choose one intention, or Not sure yet, to continue.';

  var state = { step: 1, goal: null, goalLabel: '', goalLink: '' };

  function show(n) {
    state.step = n;
    var shown = n > 3 ? 3 : n;
    steps.forEach(function (s) {
      var mine = Number(s.getAttribute('data-bw-step')) === n;
      s.hidden = !mine;
      if (mine) {
        if (label) label.textContent = s.getAttribute('data-bw-step-label') || '';
        if (count) count.textContent = shown + ' / 3';
        if (line) line.style.setProperty('--progress', (shown / 3 * 100) + '%');
        var h = s.querySelector('h2');
        if (h) h.focus({ preventScroll: true });
      }
    });
    if (restart) restart.hidden = n === 1;
  }

  function fill(template, word) {
    return (template || '').replace('{goal}', word);
  }

  function prepareSignup() {
    var chosen = state.goal !== '' && state.goal !== null;
    var word = (state.goalLabel || '').toLowerCase();
    if (heading) heading.textContent = chosen ? fill(heading.getAttribute('data-chosen'), word) : heading.getAttribute('data-none');
    if (copy) copy.textContent = chosen ? fill(copy.getAttribute('data-chosen'), word) : copy.getAttribute('data-none');
    if (related) {
      var arrow = related.querySelector('svg');
      var useNeed = chosen && state.goalLink;
      related.setAttribute('href', useNeed ? state.goalLink : related.getAttribute('data-shop'));
      related.textContent = related.getAttribute('data-label-browse');
      if (arrow) related.appendChild(arrow);
    }
  }

  goals.forEach(function (b) {
    listen(b,'click', function () {
      state.goal = b.getAttribute('data-bw-goal') || '';
      state.goalLabel = b.getAttribute('data-bw-goal-label') || '';
      state.goalLink = b.getAttribute('data-bw-goal-link') || '';
      goals.forEach(function (o) {
        var on = o === b;
        o.setAttribute('aria-pressed', on ? 'true' : 'false');
        var mark = o.querySelector('[data-bw-mark]');
        if (mark) mark.textContent = on ? '✓' : '+';
      });
      if (goalError) goalError.textContent = '';
    });
  });

  listen(root,'click', function (e) {
    var go = e.target.closest('[data-bw-quiz-go]');
    if (go) { invalidate(); show(Number(go.getAttribute('data-bw-quiz-go'))); return; }
    if (e.target.closest('[data-bw-quiz-next]')) {
      if (state.goal === null) {
        if (goalError) goalError.textContent = goalErrorCopy;
        var first = goals[0];
        if (first) first.focus();
        return;
      }
      prepareSignup();
      show(3);
      return;
    }
    if (e.target.closest('[data-bw-quiz-restart]')) {
      invalidate();
      state.goal = null; state.goalLabel = ''; state.goalLink = '';
      goals.forEach(function (o) { o.setAttribute('aria-pressed', 'false'); var m = o.querySelector('[data-bw-mark]'); if (m) m.textContent = '+'; });
      if (goalError) goalError.textContent = '';
      if (formError) formError.textContent = '';
      if (form) form.reset();
      show(1);
    }
  });

  var ERROR_COPY = {
    invalid_email: 'That email was not accepted. Check it for a typo and try again.',
    network: 'We could not reach our server. Check your connection and try again.',
    unavailable: 'This browser blocked the sign up. Email support@optibiosupplements.com and we will send your plan.'
  };
  function errorFor(reason) {
    return ERROR_COPY[reason] || 'Something went wrong on our side, so your plan was not sent. Try again, or email support@optibiosupplements.com and we will send it.';
  }

  var UNCONFIRMED = 'We could not confirm your sign up. Check your inbox before trying again.';
  function post(body) {
    if (!ENDPOINT || !window.fetch) return Promise.resolve({ ok:false,reason:'unavailable' });
    requestController=new AbortController();
    var activeRequest=requestController;
    var timer;
    var request=window.fetch(ENDPOINT,{
      method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body),keepalive:true,signal:activeRequest.signal
    }).then(function(res){return res.json().then(function(data){
      if(!res.ok || !data || data.ok!==true)return {ok:false,reason:(data&&data.error)||('http_'+res.status)};
      return {ok:true,data:data};
    });}).catch(function(){return {ok:false,reason:'unconfirmed'};});
    var timeout=new Promise(function(resolve){timer=setTimeout(function(){activeRequest.abort();resolve({ok:false,reason:'unconfirmed'});},15000);});
    return Promise.race([request,timeout]).finally(function(){clearTimeout(timer);});
  }

  if (form) {
    var emailInput = form.querySelector('input[name="email"]');
    var phoneInput = form.querySelector('input[name="phone"]');
    var emailConsent = form.querySelector('input[name="email_consent"]');
    var smsConsent = form.querySelector('input[name="sms_consent"]');

    function fail(msg, field) {
      if (formError) formError.textContent = msg;
      [emailInput,phoneInput,emailConsent,smsConsent].forEach(function(input){if(input)input.setAttribute('aria-invalid',field===input?'true':'false');});
      if (field) field.focus();
    }

    listen(form,'submit', function (e) {
      e.preventDefault();
      if(pending)return;
      var email = (emailInput.value || '').trim();
      var phone = (phoneInput.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return fail('Enter a valid email address to continue.', emailInput);
      if (!emailConsent.checked) return fail('Tick the email box so we can send your plan.', emailConsent);
      if (phone && !smsConsent.checked) return fail('Tick the text message box, or leave the phone number empty.', smsConsent);
      if (!phone && smsConsent.checked) return fail('Add a phone number for text messages, or untick the box.', phoneInput);
      if (phone && phone.replace(/\D/g, '').length < 10) return fail('Enter a phone number with at least 10 digits.', phoneInput);

      fail('', null);
      pending=true;var token=++generation;
      submitBtn.disabled = true;submitBtn.setAttribute('aria-busy','true');
      var body = {
        email: email,
        wellness_goal: state.goal || '',
        source: SOURCE,
        phone: smsConsent.checked ? phone : '',
        sms_consent: smsConsent.checked
      };
      post(body).then(function (r) {
        if(token!==generation||lifecycle.signal.aborted)return;
        pending=false;submitBtn.disabled=false;submitBtn.removeAttribute('aria-busy');
        if (!r.ok) return fail(r.reason==='unconfirmed'?UNCONFIRMED:errorFor(r.reason), emailInput);
        if (doneCopy) doneCopy.textContent = (doneCopy.getAttribute('data-template') || '').replace('{email}', email);
        show(4);
      });
    });
  }

  show(1);
  }
  function mount(){document.querySelectorAll('[data-bw-quiz]').forEach(initialize);}
  mount();document.addEventListener('shopify:section:load',mount);
  document.addEventListener('shopify:section:unload',function(e){for(var entry of instances){if(e.target.contains(entry[0])){entry[1]();instances.delete(entry[0]);}}});
})();
